import { createAction } from 'redux-actions';
import {
  SHOW_MODAL,
  SET_SCREEN,
  LOAD_PROFILES,
  LOAD_AVATARS,
  UPDATE_PROFILE,
  DELETE_PROFILE,
  ADD_PROFILE,
} from './constants';

export const showModal = createAction(SHOW_MODAL);
export const setScreen = createAction(SET_SCREEN);

export const loadProfiles = createAction(LOAD_PROFILES.ACTION);
export const loadProfilesLoading = createAction(LOAD_PROFILES.PENDING);
export const loadProfilesSuccess = createAction(LOAD_PROFILES.SUCCESS);
export const loadProfilesError = createAction(LOAD_PROFILES.ERROR);
export const loadProfilesClear = createAction(LOAD_PROFILES.CLEAR);

export const loadAvatars = createAction(LOAD_AVATARS.ACTION);
export const loadAvatarsLoading = createAction(LOAD_AVATARS.PENDING);
export const loadAvatarsSuccess = createAction(LOAD_AVATARS.SUCCESS);
export const loadAvatarsError = createAction(LOAD_AVATARS.ERROR);
export const loadAvatarsClear = createAction(LOAD_AVATARS.CLEAR);

export const updateProfile = createAction(UPDATE_PROFILE.ACTION);
export const updateProfileLoading = createAction(UPDATE_PROFILE.PENDING);
export const updateProfileSuccess = createAction(UPDATE_PROFILE.SUCCESS);
export const updateProfileUsernameSuccess = createAction(
  UPDATE_PROFILE.USERNAME,
);
export const updateProfileError = createAction(UPDATE_PROFILE.ERROR);
export const updateProfileClear = createAction(UPDATE_PROFILE.CLEAR);

export const deleteProfile = createAction(DELETE_PROFILE.ACTION);
export const deleteProfileLoading = createAction(DELETE_PROFILE.PENDING);
export const deleteProfileSuccess = createAction(DELETE_PROFILE.SUCCESS);
export const deleteProfileError = createAction(DELETE_PROFILE.ERROR);
export const deleteProfileClear = createAction(DELETE_PROFILE.CLEAR);

export const addProfile = createAction(ADD_PROFILE.ACTION);
export const addProfileLoading = createAction(ADD_PROFILE.PENDING);
export const addProfileSuccess = createAction(ADD_PROFILE.SUCCESS);
export const addProfileError = createAction(ADD_PROFILE.ERROR);
export const addProfileClear = createAction(ADD_PROFILE.CLEAR);
